<div id="webRegistrierungZwischenseite">
  <app-registrierung-zwischenseite></app-registrierung-zwischenseite>
</div>
